import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Button } from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';

import svgImage8 from '../../assets/images/illustrations/403.jpg';

export default function PagesError403() {
  return (
    <div className="app-wrapper bg-secondary">
      <div className="app-main">
        <div className="app-content p-0">
          <div className="app-inner-content-layout--main">
            <div className="flex-grow-1 w-100 d-flex align-items-center" style={{ backgroundColor: 'white' }}>
              <div className="bg-composed-wrapper--content">
                <div className="hero-wrapper bg-composed-wrapper min-vh-100">
                  <div className="flex-grow-1 w-100 d-flex align-items-center">
                    <Grid
                      item
                      lg={6}
                      md={9}
                      className="px-4 mx-auto text-center text-black"
                    >
                      <img
                        src={svgImage8}
                        className="w-50 mx-auto d-block my-5 img-fluid"
                        alt=""
                      />

                      <h1 className="display-1 mb-3 px-4 font-weight-bold">
                        Ops!
                      </h1>
                      <h3 className="font-size-xxl line-height-sm font-weight-light d-block px-3 mb-3 text-black-50">
                        Você não tem permissões suficientes.
                      </h3>
                      <p>
                        Por favor entre em contato com nossa central de atendimento.
                      </p>
                      <Button
                        component={RouterLink}
                        to="/login"
                        size="large"
                        color="primary"
                        variant="contained"
                        className="text-white mt-4"
                      >
                        <span className="btn-wrapper--icon">
                          <FontAwesomeIcon icon={['fas', 'arrow-left']} />
                        </span>
                        <span className="btn-wrapper--label">
                          Voltar para o login
                        </span>
                      </Button>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
